export default __webpack_public_path__ + "static/media/half-moon.4946e6c2.svg";